import React from "react";
import { Toast, Button, Icon, Modal } from "antd-mobile";
import { CloseCircleOutline } from "antd-mobile-icons";
import { post } from "../../utils/request";
import api from "../api";
import { href, versionStringCompare, viewPort } from "../../utils/util";
import "./index.less";
var timer = "";
var setActiveBtnType = false;
// /ActivityModule?activityCode=uwth202404023045&app_stoken=xxxx&source=huilian&channel=抖音
// /ActivityModule?activityCode=uwth202404023045&source=huilian
class ActivityModuleIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detailData: {
                activityAssemblyList: [],
            },
            urlOps: {},
            active: "",
            lotteryNum: 0,
            lotteryItem: {},
            lotteryType: false,
            viewPort: viewPort(),
            activityCode: "",
            assemblyLottery: {},
            entrySource: "",
            dialogShow: false,
            modal: false,
            claimedFlagType: 0,

            // 注册
            iconType: false,
            second: 59,
            secondType: false,
            inputBlur1: true,
            inputBlur2: true,
            inputBlur3: true,
            mobileNumber: "",
            img: "",
            TPYZMtype: false,
            TPyanzhengma: "",
            recordCode: "",
            HK: {},
            TPYZMstatus: "",
        };
    }
    componentDidMount() {
        window.didLogin = this.didLogin;
        var obj = "",
            obj1 = "",
            ops = {};

        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] = obj1[i].split("=")[1];
            }

            const { viewPort } = this.state;
            this.setState({
                activityCode: ops.activityCode,
            });

            // 埋点
            let userName = "";
            if (!ops.source || ops.source !== "huilian") {
                this.setState(
                    {
                        urlOps: ops,
                        entrySource: "weixin",
                    },
                    () => {
                        this.getWXDetail();
                    }
                );
                React.$hlInsight.track("Activity_HomePage_Ck", {
                    activityCode: ops.activityCode,
                    userName: userName,
                });
                return;
            } else {
                if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                    if (window.webkit) {
                        userName = window.prompt("getUserName", "");
                    }
                } else {
                    if (window.huilian) {
                        userName = window.huilian.getUserName();
                    }
                }
            }
            React.$hlInsight.track("Activity_HomePage_Ck", {
                activityCode: ops.activityCode,
                userName: userName,
            });
            if (
                ops.app_stoken === "null" ||
                ops.app_stoken === "(null)" ||
                ops.app_stoken === "undefined" ||
                !ops.app_stoken
            ) {
                let app_stoken = "";
                if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                    if (window.webkit) {
                        app_stoken = window.prompt("getAppToken", "");
                    }
                } else {
                    if (window.huilian) {
                        app_stoken = window.huilian.getAppToken();
                    }
                }
                if (!app_stoken) {
                    this.login();
                    return;
                }
                this.setState(
                    {
                        urlOps: {
                            ...ops,
                            app_stoken,
                        },
                    },
                    () => {
                        this.getDetail();
                    }
                );
            } else {
                this.setState(
                    {
                        urlOps: ops,
                    },
                    () => {
                        this.getDetail();
                    }
                );
            }
            this.getVersion(1);
        }
    }

    getVersion(type) {
        var version = "";
        const { viewPort } = this.state;
        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
            if (window.webkit) {
                if (window.prompt("getAppVersion")) {
                    version = window.prompt("getAppVersion");
                    if (versionStringCompare("3.4.9", version) != -1) {
                        if (type) {
                            this.setState({
                                dialogShow: true,
                            });
                        } else {
                            Toast.info("请升级至最新版本参与活动～", 1);
                            return true;
                        }
                    }
                } else {
                    if (type) {
                        this.setState({
                            dialogShow: true,
                        });
                    } else {
                        Toast.info("请升级至最新版本参与活动～", 1);
                        return true;
                    }
                }
            }
        } else {
            return false;
        }
        return false;
    }

    login() {
        const { viewPort } = this.state;
        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
            if (window.webkit) {
                window.webkit.messageHandlers.login.postMessage("");
            }
        } else {
            if (window.huilian) {
                window.huilian.login("");
            }
        }
    }
    didLogin(token) {
        let url = window.location.href + "&app_stoken=" + token;
        let v = viewPort();
        if (v.ios || v.iPhone || v.iPad) {
            if (window.webkit) {
                window.location.replace(url);
                window.location.reload();
            }
        } else {
            if (window.huilian) {
                window.huilian.goBack("");
                window.huilian.openNewWeb(url);
            }
        }
    }

    // 获取详情
    getDetail() {
        post({
            url:
                api.selectMarketingActivityDetailByUser +
                "?app_stoken=" +
                this.state.urlOps.app_stoken,
            data: {
                activityCode: this.state.urlOps.activityCode,
            },
        }).then((res) => {
            if (!(res && res.data)) {
                return;
            }
            const data = this.formatData(res);
            this.getClaimedFlag();
            if (data.needShare === 1) {
                const { viewPort } = this.state;
                if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                    if (window.webkit) {
                        window.webkit.messageHandlers.showShare.postMessage({
                            title: data.shareTitle,
                            content: data.shareContent,
                            url: data.shareAppUrl.replace("source=huilian", ""),
                            img: data.shareImg,
                        });
                    }
                } else {
                    if (window.huilian) {
                        window.huilian.showShareWeixin(
                            data.shareAppUrl.replace("source=huilian", ""),
                            data.shareTitle,
                            data.shareContent,
                            data.shareImg
                        );
                    }
                }
            }
            Toast.hide();
        });
    }
    getWXDetail() {
        post({
            url: api.selectMarketingActivityDetailForFree,
            data: {
                activityCode: this.state.urlOps.activityCode,
            },
        }).then((res) => {
            if (!(res && res.data)) {
                return;
            }
            this.formatData(res);
        });
    }
    formatData(res) {
        let data = {
            ...res.data,
            shareImg: res.data.needShare === 1 ? res.data.shareImg : "",

            mainImg: res.data.mainImg,
            ruleImg: res.data.ruleImg,
            prizeImg: res.data.prizeImg,
        };
        document.getElementsByTagName("title")[0].text = res.data.activityName;
        if (data.activityAssemblyList.length > 0) {
            const activityAssemblyList = data.activityAssemblyList.map(
                (item) => {
                    let assemblyTaskList = [];
                    if (item.assemblyTaskList) {
                        assemblyTaskList = item.assemblyTaskList.map((obj) => {
                            if (obj) {
                                return {
                                    ...obj,
                                    taskImg: obj.taskImg ? obj.taskImg : "",
                                };
                            } else {
                                return {};
                            }
                        });
                    }
                    if (item.assemblyType === 5) {
                        const { urlOps } = this.state;
                        if (urlOps.source && urlOps.source === "huilian") {
                            this.userLotteryMarketingNum(item.assemblyLottery);
                        }
                    }

                    if (item.assemblyType === 2) {
                        if (item.couponsNum > 3) {
                            let type = 0;
                            for (
                                var i = 0;
                                i < item.assemblyCouponsList.length;
                                i++
                            ) {
                                if (item.assemblyCouponsList[i] === 1) {
                                    type = 1;
                                    break;
                                }
                            }
                            item.couponsStatus = type;
                        }
                    }
                    return {
                        ...item,
                        assemblyImg: item.assemblyImg,
                        buttonNotReceiveImg: item.buttonNotReceiveImg,
                        buttonReceiveImg: item.buttonReceiveImg,
                        buttonNotFinishImg: item.buttonNotFinishImg,
                        buttonFinishImg: item.buttonFinishImg,
                        assemblyCouponsList: item.assemblyCouponsList,
                        assemblyTaskList,
                        assemblyLottery: item.assemblyLottery,
                    };
                }
            );
            activityAssemblyList.sort(function compare(a, b) {
                if (a.order < b.order) {
                    return -1;
                }
                if (a.order > b.order) {
                    return 1;
                }
                return 0;
            });
            data.activityAssemblyList = activityAssemblyList;
        }

        this.setState({
            detailData: data,
        });
        return data;
    }

    // 获取抽奖次数
    userLotteryMarketingNum(item) {
        post({
            url:
                item.lotteryLimitType == 0
                    ? api.userLotteryMarketingNum +
                      "?app_stoken=" +
                      this.state.urlOps.app_stoken
                    : api.userTotalIntegral +
                      "?app_stoken=" +
                      this.state.urlOps.app_stoken,
            data: {
                activityAssemblyCode: item.activityAssemblyCode,
            },
        }).then((res) => {
            if (!(res && res.data)) {
                if (res.data == 0) {
                    this.setState({
                        lotteryNum: res.data,
                    });
                }
                return;
            }
            this.setState({
                lotteryNum:
                    item.lotteryLimitType == 0
                        ? res.data
                        : res.data.totalIntegral,
            });
        });
    }

    // 领取优惠券
    receiveMarketingCoupons(item) {
        if (this.state.entrySource === "weixin") {
            this.JumpDownload();
            return;
        }
        post({
            url:
                api.receiveMarketingCoupons +
                "?app_stoken=" +
                this.state.urlOps.app_stoken,
            data: {
                activityAssemblyCouponsCode: item.activityAssemblyCouponsCode,
            },
        }).then((res) => {
            if (res.result === "success") {
                Toast.success("领取成功", 1);
                this.getDetail();
            } else {
                Toast.info(res.msg.replace("数据异常：", ""), 1);
            }
        });
    }

    // 一键领取
    receiveMarketingAllCoupons(item) {
        if (this.state.entrySource === "weixin") {
            this.JumpDownload();
            return;
        }
        Toast.loading("领取中…", 0);
        post({
            url:
                api.receiveMarketingAllCoupons +
                "?app_stoken=" +
                this.state.urlOps.app_stoken,
            data: {
                activityAssemblyCode: item.activityAssemblyCode,
            },
        }).then((res) => {
            if (res.result === "success") {
                // Toast.success("领取成功", 1);
                // Toast.success({
                //     content: "为保证使用顺畅，请升级至最新版本",
                //     duration: 3,
                // });
                setTimeout(() => {
                    this.getDetail();
                }, 3000);
            } else {
                Toast.info(res.msg.replace("数据异常：", ""), 1);
            }
        });
    }

    // 抽奖
    setActive(params) {
        this.setState({
            modal: false,
        });
        if (this.state.entrySource === "weixin") {
            return;
        }
        if (setActiveBtnType) {
            return;
        }
        if (params.lotteryLimitType == 0) {
            if (this.state.lotteryNum <= 0) {
                Toast.info("抽奖次数为0", 1);
                return;
            }
        } else if (params.lotteryLimitType == 1) {
            if (params.userTotalIntegral - params.consumeIntegral <= 0) {
                Toast.info("积分不够，暂时无法抽奖～", 1);
                return;
            }
        }

        this.setState({
            assemblyLottery: params,
        });
        setActiveBtnType = true;
        const path = [0, 1, 2, 4, 7, 6, 5, 3];
        let curIndex = 0;
        let stop = false;

        timer = setInterval(() => {
            if (curIndex > 7) {
                curIndex = 0;
            }

            if (stop) {
                setActiveBtnType = false;
                clearInterval(timer);
            }

            this.setState({
                active: "active" + path[curIndex],
            });

            curIndex++;
        }, 100);

        post({
            url:
                api.lotteryMarketingPrize +
                "?app_stoken=" +
                this.state.urlOps.app_stoken,
            data: {
                activityAssemblyCode: params.activityAssemblyCode,
            },
        }).then((res) => {
            if (!(res && res.data)) {
                stop = true;
                setActiveBtnType = false;
                clearInterval(timer);
                this.setState({
                    active: "active0",
                });
                Toast.info(res.msg.replace("数据异常：", ""), 1);
                return;
            }

            if (res.data.resultCode === 2) {
                stop = true;
                setActiveBtnType = false;
                clearInterval(timer);
                this.setState({
                    active: "active0",
                });
                // 授权
                this.authToken(res.data);
            } else {
                let lotteryItem = {},
                    index = 0;
                for (var i = 0; i < params.prizelList.length; i++) {
                    if (
                        res.data.activityPrizeCode ===
                        params.prizelList[i].activityPrizeCode
                    ) {
                        lotteryItem = params.prizelList[i];
                        index = i;
                        this.setState({
                            lotteryItem: { ...lotteryItem, ...res.data },
                        });
                        break;
                    }
                }

                setTimeout(() => {
                    // if (res.data.resultCode === 0) {
                    // Toast.info("未中奖", 1);
                    // } else {
                    // }
                    stop = true;
                    clearInterval(timer);
                    // if (path[curIndex] === index) {
                    //   console.log("1、", curIndex, index, path[curIndex]);
                    //   setActiveBtnType = false;
                    //   this.setState({
                    //     lotteryType: true,
                    //   });
                    // } else {
                    timer = setInterval(() => {
                        if (curIndex > 7) {
                            curIndex = 0;
                        }
                        // console.log("2、", curIndex, index, path[curIndex]);
                        if (path[curIndex] === index) {
                            setActiveBtnType = false;
                            this.setState({
                                active: "active" + path[curIndex],
                            });
                            clearInterval(timer);
                            setTimeout(() => {
                                this.setState({
                                    lotteryType: true,
                                });
                            }, 500);
                        } else {
                            this.setState({
                                active: "active" + path[curIndex],
                            });
                        }

                        curIndex++;
                    }, 300);
                    // }
                }, 2000);
            }
            this.userLotteryMarketingNum(params);
        });
    }

    // 领奖
    receiveMarketingTaskPrize(item) {
        post({
            url:
                api.receiveMarketingTaskPrize +
                "?app_stoken=" +
                this.state.urlOps.app_stoken,
            data: {
                activityAssemblyTaskCode: item.activityAssemblyTaskCode,
            },
        }).then((res) => {
            if (!(res && res.data)) {
                return;
            }
            if (res.result === "success") {
                if (res.data.receiveResult === 1) {
                    Toast.success("领取成功", 1);
                    this.getDetail();
                }
                if (res.data.receiveResult === 2) {
                    this.authToken(res.data);
                }
            } else {
                Toast.info(res.msg.replace("数据异常：", ""), 1);
            }
        });
    }

    // 领取礼包
    receiveMarketingPrizes() {
        // if (this.state.entrySource === "weixin") {
        //     this.JumpDownload();
        //     return;
        // }
        post({
            url:
                api.receiveMarketingPrizes +
                "?app_stoken=" +
                this.state.urlOps.app_stoken,
            data: {
                activityCode: this.state.urlOps.activityCode,
            },
        }).then((res) => {
            // if (!(res && res.data)) {
            //     return;
            // }
            if (res.result === "success") {
                Toast.success("领取成功，可于我的-优惠券中查看。", 1);
                this.getClaimedFlag();
            } else {
                Toast.info(res.msg.replace("数据异常：", ""), 1);
            }
        });
    }

    // 获取礼包领取状态
    getClaimedFlag() {
        post({
            url:
                api.receivedMarketingPrizesFlag +
                "?app_stoken=" +
                this.state.urlOps.app_stoken,
            data: {
                activityCode: this.state.urlOps.activityCode,
            },
        }).then((res) => {
            // if (!(res && res.data)) {
            //     return;
            // }
            if (res.result === "success") {
                this.setState({
                    claimedFlagType: res.data,
                });
            } else {
                Toast.info(res.msg.replace("数据异常：", ""), 1);
            }
        });
    }

    authToken(data) {
        const { viewPort } = this.state;
        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
            if (window.webkit) {
                window.webkit.messageHandlers.sendWXAuthReq.postMessage({
                    authToken: data.authToken,
                });
            }
        } else {
            if (window.huilian) {
                window.huilian.sendWXAuthReq(data.authToken);
            }
        }
    }

    Jump(data) {
        if (this.state.entrySource === "weixin") {
            this.JumpDownload();
            return;
        }
        if (data.jumpType === 1) {
            window.location.href = data.jumpUrl;
        }
        if (data.jumpType === 2) {
            if (
                ["annual", "maintenance", "chargeCard", "etc"].includes(
                    data.jumpUrl
                )
            ) {
                const needUpdate = this.getVersion();
                if (needUpdate) {
                    return;
                }
            }
            const { viewPort } = this.state;
            if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                if (window.webkit) {
                    window.webkit.messageHandlers[data.jumpUrl].postMessage(
                        "1"
                    );
                }
            } else {
                if (window.huilian) {
                    if (data.jumpUrl === "linkCarBind") {
                        window.huilian[data.jumpUrl]();
                    } else {
                        window.huilian[data.jumpUrl]("");
                    }
                }
            }
        }
        if (data.jumpType === 3) {
            const { viewPort } = this.state;
            if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                if (window.webkit) {
                    window.webkit.messageHandlers.miniProgram.postMessage({
                        miniSource: "lshl",
                        path: data.jumpUrl,
                    });
                }
            } else {
                if (window.huilian) {
                    window.huilian.miniProgram("lshl", data.jumpUrl);
                }
            }
        }
        if (data.jumpType === 4) {
            const { viewPort } = this.state;
            if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                if (window.webkit) {
                    window.webkit.messageHandlers.miniProgram.postMessage({
                        miniSource: "hcd",
                        path: data.jumpUrl,
                    });
                }
            } else {
                if (window.huilian) {
                    window.huilian.miniProgram("hcd", data.jumpUrl);
                }
            }
        }
    }

    JumpDownload() {
        window.location.href = "https://st.hellogil.com/4a1gAx";
    }

    // 注册
    getCreateSlideImage() {
        var shouji = document.getElementById("shouji").value;
        post({
            url: api.createSlideImage,
            data: {
                phoneNumber: shouji,
                businessType: "LOG_IN",
                imageType: "APP",
            },
        }).then(
            (res) => {
                // console.log('图片验证码', res);
                if (res.result === "success") {
                    // this.setState({
                    //     // TPYZMtype: true,
                    //     img: "data:image/jpeg;base64," + res.data,
                    // });
                    this.setState({
                        TPYZMstatus: "",
                        HK: {
                            backgroundImage:
                                "data:image/jpeg;base64," +
                                res.data.backgroundImage,
                            slideImage:
                                "data:image/jpeg;base64," + res.data.slideImage,
                        },
                    });
                } else {
                    Toast.info("图片获取失败", 1);
                }
            },
            (res) => {
                Toast.info("图片获取失败", 1);
            }
        );
    }
    getMessageCode = () => {
        var shouji = document.getElementById("shouji").value;
        if (!new RegExp(/^1[0-9][0-9]\d{8}$/).test(shouji)) {
            Toast.info("请填写正确的手机号码", 1);
            return;
        }

        clearInterval(timer);
        this.setState(
            {
                secondType: false,
                TPYZMtype: true,
                TPYZMstatus: "error",
            },
            () => {
                document.getElementsByClassName("HKimgSlider")[0].style.left =
                    "0px";
                document.getElementsByClassName("sliderBtn")[0].style.left =
                    "0px";
                this.getCreateSlideImage();
            }
        );
    };

    timerFN = () => {
        const { TPyanzhengma } = this.state;
        var shouji = document.getElementById("shouji").value;
        if (!new RegExp(/^1[0-9][0-9]\d{8}$/).test(shouji)) {
            Toast.info("请填写正确的手机号码", 1);
            return;
        }

        clearInterval(timer);
        let _this = this;
        post({
            url: api.messageCode,
            data: {
                phoneNumber: shouji,
                businessType: "LOG_IN",
                imageCode: TPyanzhengma || "",
                check: "slide",
            },
        }).then(
            (res) => {
                console.log("验证码", res);
                if (res.result === "success") {
                    _this.setState(
                        {
                            second: 59,
                            secondType: true,
                            recordCode: res.data,
                            TPYZMstatus: "success",
                        },
                        () => {
                            this.setState({
                                TPYZMtype: false,
                            });
                            let { second } = _this.state;
                            timer = setInterval(function () {
                                if (second < 0) {
                                    clearInterval(timer);
                                    _this.setState({
                                        secondType: false,
                                    });
                                } else {
                                    _this.setState({
                                        second: second--,
                                    });
                                }
                            }, 1000);
                        }
                    );
                } else if (res.code === "BD001000000998") {
                    this.getMessageCode();
                    Toast.info("图片验证码填写错误", 2);
                } else if (res.code === "BD001000000997") {
                    this.getMessageCode();
                    Toast.info("请输入图片验证码", 1);
                } else {
                    this.setState({
                        TPyanzhengma: "",
                    });
                    if (this.state.TPYZMtype) {
                        this.getMessageCode();
                        Toast.info("验证失败，请重试", 1);
                    } else {
                        // Toast.info(res.msg.replace('数据异常：',''), 1);
                    }
                }
            },
            (res) => {
                this.setState({
                    TPyanzhengma: "",
                });
                Toast.info(res.msg.replace("数据异常：", ""), 1);
            }
        );
    };

    focusFN = (type) => {
        if (type === 1) {
            this.setState({
                inputBlur1: false,
            });
        } else if (type === 2) {
            this.setState({
                inputBlur2: false,
            });
        } else {
            this.setState({
                inputBlur3: false,
            });
        }
    };

    blurFN = (type) => {
        if (type === 1) {
            var value = document.getElementById("shouji").value;
            if (!value) {
                this.setState({
                    inputBlur1: true,
                });
            }
        } else if (type === 2) {
            // var value = document.getElementById('TPyanzhengma').value;
            // if(!value){
            //     this.setState({
            //         inputBlur2: true
            //     });
            // }
        } else {
            var value = document.getElementById("yanzhengma").value;
            if (!value) {
                this.setState({
                    inputBlur3: true,
                });
            }
        }
    };
    submit = () => {
        var shouji = document.getElementById("shouji").value;
        var yanzhengma = document.getElementById("yanzhengma").value;
        if (!new RegExp(/^1[0-9][0-9]\d{8}$/).test(shouji)) {
            Toast.info("请填写正确的手机号码", 1);
            return;
        }
        if (!yanzhengma) {
            Toast.info("请填写验证码", 1);
            return;
        }
        if (!this.state.iconType) {
            Toast.info("同意《用户协议》《隐私政策》后才可登录", 1);
            return;
        }

        post({
            url: api.messageLogin,
            data: {
                phoneNumber: shouji,
                messageCode: yanzhengma,
                recordCode: this.state.recordCode,
                channel: "REGISTER_H5",
                subChannel: this.state.urlOps.channel || "",
                activityCode: this.state.urlOps.activityCode || "",
            },
        }).then(
            (res) => {
                console.log("注册", res);
                if (res.data && res.result === "success") {
                    if (!res.data.register) {
                        Toast.info("你已注册", 1);
                    } else {
                        Toast.info("注册成功", 1);
                    }
                    clearInterval(timer);
                    this.JumpDownload();
                } else {
                    Toast.info(res.msg.replace("数据异常：", ""), 1);
                }
            },
            (res) => {
                Toast.info("注册失败", 1);
            }
        );
    };

    FnStart(ev) {
        this.boxW =
            document.getElementsByClassName("sliderLine")[0].offsetWidth;
        this.imgHtml = document.getElementsByClassName("HKimgSlider")[0];
        this.Touch = ev.changedTouches[0];

        this.startX = this.Touch.pageX - ev.target.offsetLeft;

        // this.startY = this.Touch.pageY - ev.target.offsetTop;

        document.ontouchmove = this.FnMove.bind(this);

        document.ontouchend = this.FnEnd.bind(this);
    }

    FnMove(ev) {
        this.Touch = ev.changedTouches[0];

        this.X = this.Touch.pageX - this.startX;

        this.bX = this.X - 18;
        // this.Y = this.Touch.pageY - this.startY;
        if (this.bX < 0) {
            this.bX = 0;
        }
        if (this.bX > this.boxW - 56) {
            this.bX = this.boxW - 56;
        }
        if (this.X < 0) {
            this.X = 0;
        }
        if (this.X > this.boxW - this.imgHtml.offsetWidth) {
            this.X = this.boxW - this.imgHtml.offsetWidth;
        }
        // console.log(ev);
        ev.target.style.left = this.bX + "px";
        this.imgHtml.style.left = this.X + "px";
        console.log(this.bX);
        console.log(this.X);
        // ev.target.style.top = this.Y + "px";
    }

    FnEnd(ev) {
        const frontendMax = 256; // 滑动条总长度

        // 服务端参数
        const backendMax = 590; // 服务端验证范围480px
        // 计算两个比例关系
        const sliderToBackend = (this.X / frontendMax) * backendMax;

        this.setState(
            {
                TPyanzhengma: Math.floor(sliderToBackend),
            },
            () => {
                this.timerFN();
            }
        );
        document.ontouchmove = null;
        document.ontouchend = null;
    }

    render() {
        const {
            detailData,
            active,
            lotteryNum,
            lotteryItem,
            lotteryType,
            assemblyLottery,
            dialogShow,
            viewPort,
            urlOps,
            claimedFlagType,

            iconType,
            second,
            secondType,
            inputBlur1,
            inputBlur2,
            recordCode,
            inputBlur3,
            TPYZMtype,
            img,
            HK,
            TPYZMstatus,
        } = this.state;
        return (
            <div
                className="ActivityModuleIndex"
                style={{ background: detailData.color || "#fff" }}
            >
                {/* 主图 */}
                {detailData.needMainImg === 1 ? (
                    <div className="MainImage">
                        <img src={detailData.mainImg} />
                    </div>
                ) : (
                    ""
                )}
                {detailData.needRule === 1 || detailData.needPrize === 1 ? (
                    <div className="rule">
                        {/* 规则 */}
                        {detailData.needRule === 1 ? (
                            <div
                                onClick={() => {
                                    if (this.state.entrySource === "weixin") {
                                        this.JumpDownload();
                                        return;
                                    }
                                    href(
                                        `/ActivityModuleRule?app_stoken=${
                                            this.state.urlOps.app_stoken
                                        }&activityCode=${
                                            this.state.urlOps.activityCode
                                        }&color=${detailData.color || "#fff"}`
                                    );
                                }}
                            >
                                <img src={detailData.ruleImg} />
                            </div>
                        ) : (
                            ""
                        )}
                        {/* 奖励列表 */}
                        {detailData.needPrize === 1 ? (
                            <div
                                onClick={() => {
                                    if (this.state.entrySource === "weixin") {
                                        this.JumpDownload();
                                        return;
                                    }
                                    href(
                                        `/ActivityModuleRecord?app_stoken=${
                                            this.state.urlOps.app_stoken
                                        }&activityCode=${
                                            this.state.urlOps.activityCode
                                        }&color=${detailData.color || "#fff"}`
                                    );
                                }}
                            >
                                <img src={detailData.prizeImg} />
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                ) : (
                    ""
                )}
                {detailData.activityAssemblyList.map((item, index) => {
                    // 单个领劵
                    if (item.assemblyType === 1) {
                        return (
                            <div
                                className="blockItem RW1"
                                key={index}
                            >
                                <img src={item.assemblyImg} />
                                {item.assemblyCouponsList[0].couponsStatus ===
                                1 ? (
                                    <img src={item.buttonReceiveImg} />
                                ) : (
                                    <img
                                        src={item.buttonNotReceiveImg}
                                        onClick={() => {
                                            this.receiveMarketingCoupons(
                                                item.assemblyCouponsList[0]
                                            );
                                        }}
                                    />
                                )}
                            </div>
                        );
                    }
                    //   多个领劵
                    if (item.assemblyType === 2) {
                        const hasStatusZero =
                            item.assemblyCouponsList &&
                            item.assemblyCouponsList.some(
                                (coupon) => coupon.couponsStatus === 0
                            );
                        return (
                            <div
                                className="blockItem RW2"
                                key={index}
                            >
                                <img src={item.assemblyImg} />
                                {item.couponsNum > 3 ? (
                                    hasStatusZero ? (
                                        <div>
                                            <img
                                                style={{
                                                    position: "absolute",
                                                    bottom: 0,
                                                }}
                                                src={item.buttonNotReceiveImg}
                                                onClick={() => {
                                                    this.receiveMarketingAllCoupons(
                                                        item
                                                    );
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <img
                                                src={item.buttonReceiveImg}
                                                style={{
                                                    position: "absolute",
                                                    bottom: 0,
                                                }}
                                            />
                                        </div>
                                    )
                                ) : (
                                    //   item.assemblyCouponsList.map((obj, j) => {
                                    //       return (
                                    //           <div key={j}>
                                    //               {obj.couponsStatus === 1 ? (
                                    //                   <img
                                    //                       src={
                                    //                           item.buttonReceiveImg
                                    //                       }
                                    //                       style={{
                                    //                           position:
                                    //                               "absolute",
                                    //                           bottom: 0,
                                    //                       }}
                                    //                   />
                                    //               ) : (
                                    //                   <img
                                    //                       style={{
                                    //                           position:
                                    //                               "absolute",
                                    //                           bottom: 0,
                                    //                       }}
                                    //                       src={
                                    //                           item.buttonNotReceiveImg
                                    //                       }
                                    //                       onClick={() => {
                                    //                           this.receiveMarketingAllCoupons(
                                    //                               item
                                    //                           );
                                    //                       }}
                                    //                   />
                                    //               )}
                                    //           </div>
                                    //       );
                                    //   })
                                    ""
                                )}
                                {item.couponsNum === 2 ? (
                                    <div
                                        className="flexBox"
                                        style={{
                                            position: "absolute",
                                            bottom: 0,
                                        }}
                                    >
                                        <div>
                                            {item.assemblyCouponsList[0]
                                                .couponsStatus === 1 ? (
                                                <img
                                                    src={item.buttonReceiveImg}
                                                />
                                            ) : (
                                                <img
                                                    src={
                                                        item.buttonNotReceiveImg
                                                    }
                                                    onClick={() => {
                                                        this.receiveMarketingCoupons(
                                                            item
                                                                .assemblyCouponsList[0]
                                                        );
                                                    }}
                                                />
                                            )}
                                        </div>
                                        <div>
                                            {item.assemblyCouponsList[1]
                                                .couponsStatus === 1 ? (
                                                <img
                                                    src={item.buttonReceiveImg}
                                                />
                                            ) : (
                                                <img
                                                    src={
                                                        item.buttonNotReceiveImg
                                                    }
                                                    onClick={() => {
                                                        this.receiveMarketingCoupons(
                                                            item
                                                                .assemblyCouponsList[1]
                                                        );
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                                {item.couponsNum === 3 ? (
                                    <div
                                        className="flexBox"
                                        style={{
                                            position: "absolute",
                                            bottom: 0,
                                        }}
                                    >
                                        <div>
                                            {item.assemblyCouponsList[0]
                                                .couponsStatus === 1 ? (
                                                <img
                                                    src={item.buttonReceiveImg}
                                                />
                                            ) : (
                                                <img
                                                    src={
                                                        item.buttonNotReceiveImg
                                                    }
                                                    onClick={() => {
                                                        this.receiveMarketingCoupons(
                                                            item
                                                                .assemblyCouponsList[0]
                                                        );
                                                    }}
                                                />
                                            )}
                                        </div>
                                        <div>
                                            {item.assemblyCouponsList[1]
                                                .couponsStatus === 1 ? (
                                                <img
                                                    src={item.buttonReceiveImg}
                                                />
                                            ) : (
                                                <img
                                                    src={
                                                        item.buttonNotReceiveImg
                                                    }
                                                    onClick={() => {
                                                        this.receiveMarketingCoupons(
                                                            item
                                                                .assemblyCouponsList[1]
                                                        );
                                                    }}
                                                />
                                            )}
                                        </div>
                                        <div>
                                            {item.assemblyCouponsList[2]
                                                .couponsStatus === 1 ? (
                                                <img
                                                    src={item.buttonReceiveImg}
                                                />
                                            ) : (
                                                <img
                                                    src={
                                                        item.buttonNotReceiveImg
                                                    }
                                                    onClick={() => {
                                                        this.receiveMarketingCoupons(
                                                            item
                                                                .assemblyCouponsList[2]
                                                        );
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        );
                    }
                    //   视频组件
                    if (item.assemblyType === 3) {
                        return (
                            <div
                                className="blockItem RW3"
                                key={index}
                            >
                                <video
                                    src={item.videoUrl}
                                    poster={item.assemblyImg || ""}
                                    // autoPlay
                                    controls
                                    // muted
                                    // webkit-playsinline="true" /*IOS中让视频在小窗内播放而不是全屏播放*/
                                    playsInline={
                                        true
                                    } /*IOS微信浏览器支持小窗内播放*/
                                    // x-webkit-airplay="allow" /*是否支持ios的AirPlay功能*/
                                    // x5-video-player-type="h5" /*启用H5播放器,是wechat安卓版特性*/
                                    style={{ objectFit: "fill", width: "100%" }}
                                ></video>
                            </div>
                        );
                    }
                    //   图片组件
                    if (item.assemblyType === 4) {
                        return (
                            <div
                                className="blockItem RW4"
                                key={index}
                            >
                                <img
                                    src={item.assemblyImg}
                                    onClick={() => {
                                        if (item.jumpType === 0) {
                                            return;
                                        }
                                        this.Jump(item);
                                    }}
                                />
                            </div>
                        );
                    }
                    //   抽奖组件
                    if (item.assemblyType === 5) {
                        return (
                            <div
                                className="blockItem RW5"
                                key={index}
                            >
                                <div>
                                    <div className="RW5_bg">
                                        <img
                                            src={
                                                item.assemblyLottery
                                                    .lotteryBackgroundImg
                                            }
                                        />
                                    </div>
                                    <div className="CJBOX">
                                        <div>
                                            <div
                                                className={
                                                    active === "active0"
                                                        ? "active"
                                                        : ""
                                                }
                                                style={{
                                                    background: `url(${item.assemblyLottery.prizelList[0].prizeImg}) no-repeat center center / contain`,
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .winSelectedImg
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={
                                                    active === "active1"
                                                        ? "active"
                                                        : ""
                                                }
                                                style={{
                                                    background: `url(${item.assemblyLottery.prizelList[1].prizeImg}) no-repeat center center / contain`,
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .winSelectedImg
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={
                                                    active === "active2"
                                                        ? "active"
                                                        : ""
                                                }
                                                style={{
                                                    background: `url(${item.assemblyLottery.prizelList[2].prizeImg}) no-repeat center center / contain`,
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .winSelectedImg
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={
                                                    active === "active3"
                                                        ? "active"
                                                        : ""
                                                }
                                                style={{
                                                    background: `url(${item.assemblyLottery.prizelList[3].prizeImg}) no-repeat center center / contain`,
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .winSelectedImg
                                                    }
                                                />
                                            </div>
                                            <div
                                                className="btn"
                                                onClick={() => {
                                                    if (
                                                        urlOps.source &&
                                                        urlOps.source ===
                                                            "huilian"
                                                    ) {
                                                        this.setState({
                                                            modal: true,
                                                        });
                                                    } else {
                                                        this.JumpDownload();
                                                    }
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .lotteryButtonImg
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={
                                                    active === "active4"
                                                        ? "active"
                                                        : ""
                                                }
                                                style={{
                                                    background: `url(${item.assemblyLottery.prizelList[4].prizeImg}) no-repeat center center / contain`,
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .winSelectedImg
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={
                                                    active === "active5"
                                                        ? "active"
                                                        : ""
                                                }
                                                style={{
                                                    background: `url(${item.assemblyLottery.prizelList[5].prizeImg}) no-repeat center center / contain`,
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .winSelectedImg
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={
                                                    active === "active6"
                                                        ? "active"
                                                        : ""
                                                }
                                                style={{
                                                    background: `url(${item.assemblyLottery.prizelList[6].prizeImg}) no-repeat center center / contain`,
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .winSelectedImg
                                                    }
                                                />
                                            </div>
                                            <div
                                                className={
                                                    active === "active7"
                                                        ? "active"
                                                        : ""
                                                }
                                                style={{
                                                    background: `url(${item.assemblyLottery.prizelList[7].prizeImg}) no-repeat center center / contain`,
                                                }}
                                            >
                                                <img
                                                    src={
                                                        item.assemblyLottery
                                                            .winSelectedImg
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {item.assemblyLottery.lotteryLimitType == 0 ? (
                                    <div style={{ marginBottom: "0.32rem" }}>
                                        我的抽奖机会：{lotteryNum}
                                    </div>
                                ) : item.assemblyLottery.lotteryLimitType ==
                                  1 ? (
                                    <div style={{ marginBottom: "0.32rem" }}>
                                        我的积分：{lotteryNum}
                                    </div>
                                ) : (
                                    ""
                                )}
                                <Modal
                                    visible={this.state.modal}
                                    transparent
                                    maskClosable={false}
                                    onClose={() => {
                                        this.setState({
                                            modal: false,
                                        });
                                    }}
                                    title={`本次需花费${
                                        item.assemblyLottery.lotteryLimitType ==
                                        0
                                            ? "1次"
                                            : item.assemblyLottery
                                                  .consumeIntegral + "积分"
                                    }`}
                                    footer={[
                                        {
                                            text: "取消",
                                            onPress: () => {
                                                this.setState({
                                                    modal: false,
                                                });
                                            },
                                        },
                                        {
                                            text: "确定",
                                            onPress: () => {
                                                this.setActive(
                                                    item.assemblyLottery
                                                );
                                            },
                                        },
                                    ]}
                                    wrapProps={{
                                        onTouchStart: this.onWrapTouchStart,
                                    }}
                                ></Modal>
                            </div>
                        );
                    }
                    //   任务组件
                    if (item.assemblyType === 6) {
                        return (
                            <div
                                className="blockItem RW6"
                                key={index}
                            >
                                <div className="RWBox">
                                    {item.assemblyTaskList.map((obj, i) => {
                                        return (
                                            <div key={i}>
                                                <div>
                                                    <img src={obj.taskImg} />
                                                </div>
                                                <div>
                                                    <div>
                                                        <b>
                                                            {
                                                                obj.assemblyTaskName
                                                            }
                                                        </b>
                                                    </div>
                                                    <div>{obj.memo}</div>
                                                </div>
                                                <div>
                                                    {obj.taskStatus === 0 ? (
                                                        <img
                                                            src={
                                                                item.buttonNotFinishImg
                                                            }
                                                            onClick={() => {
                                                                this.Jump(obj);
                                                            }}
                                                        />
                                                    ) : (
                                                        ""
                                                    )}
                                                    {obj.taskStatus === 1 &&
                                                    obj.havePrize === 0 ? (
                                                        <img
                                                            src={
                                                                item.buttonFinishImg
                                                            }
                                                        />
                                                    ) : (
                                                        ""
                                                    )}
                                                    {obj.taskStatus === 1 &&
                                                    obj.havePrize === 1 ? (
                                                        <img
                                                            src={
                                                                item.buttonNotReceiveImg
                                                            }
                                                            onClick={() => {
                                                                this.receiveMarketingTaskPrize(
                                                                    obj
                                                                );
                                                            }}
                                                        />
                                                    ) : (
                                                        ""
                                                    )}
                                                    {obj.taskStatus === 2 &&
                                                    obj.havePrize === 1 ? (
                                                        <img
                                                            src={
                                                                item.buttonReceiveImg
                                                            }
                                                        />
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    }
                    // 注册组件
                    if (item.assemblyType === 7) {
                        return (
                            <div
                                className="blockItem RW7"
                                key={index}
                            >
                                <div className="RWBox">
                                    <div className="importBox">
                                        <label htmlFor="shouji">
                                            <div className="inputBox">
                                                <input
                                                    id="shouji"
                                                    type="tel"
                                                    maxLength="11"
                                                    placeholder="请输入手机号"
                                                    onFocus={() => {
                                                        this.focusFN(1);
                                                    }}
                                                    onBlur={() => {
                                                        this.blurFN(1);
                                                    }}
                                                />
                                            </div>
                                        </label>
                                        <label htmlFor="yanzhengma">
                                            <div className="inputBox">
                                                <input
                                                    id="yanzhengma"
                                                    type="number"
                                                    placeholder="请输入验证码"
                                                    onFocus={() => {
                                                        this.focusFN(3);
                                                    }}
                                                    onBlur={() => {
                                                        this.blurFN(3);
                                                    }}
                                                />
                                            </div>
                                            {secondType ? (
                                                <div>
                                                    <div className="second secondText">
                                                        {second}S
                                                    </div>
                                                </div>
                                            ) : (
                                                <div
                                                    className="second"
                                                    onClick={
                                                        this.getMessageCode
                                                    }
                                                >
                                                    获取验证码
                                                </div>
                                            )}

                                            {recordCode ? (
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        top: "0.08rem",
                                                        left: 0,
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            color: "#999",
                                                        }}
                                                    >
                                                        请输入接收到的验证码（编号
                                                        {recordCode}）
                                                    </span>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </label>
                                    </div>
                                    <div
                                        className="agreeBox"
                                        style={{
                                            marginTop: recordCode
                                                ? "0.36rem"
                                                : "0",
                                        }}
                                    >
                                        <label
                                            onClick={() => {
                                                this.setState({
                                                    iconType: !iconType,
                                                });
                                            }}
                                        >
                                            {iconType ? (
                                                <Icon type="check" />
                                            ) : (
                                                <Icon />
                                            )}
                                            我已阅读并同意
                                        </label>
                                        <a
                                            onClick={() => {
                                                window.location.href =
                                                    "https://www.hellogil.com/h5Static/#/ServiceAgreenment";
                                            }}
                                        >
                                            《用户协议》
                                        </a>
                                        <a
                                            onClick={() => {
                                                window.location.href =
                                                    "https://www.hellogil.com/h5Static/PrivacyAgreement.html";
                                            }}
                                        >
                                            《隐私政策》
                                        </a>
                                    </div>
                                    <div
                                        className="loginBtn"
                                        onClick={() => {
                                            this.submit();
                                        }}
                                    >
                                        <img
                                            src={item.buttonRegisterImg}
                                            style={{ widht: "100%" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    }
                    // 礼包组件
                    if (item.assemblyType === 8) {
                        return (
                            <div
                                className="blockItem RW2"
                                key={index}
                            >
                                <img src={item.prizeBackgroundImg} />
                                <div>
                                    {claimedFlagType == 1 ? (
                                        <img
                                            src={item.buttonReceiveImg}
                                            style={{
                                                position: "absolute",
                                                bottom: 0,
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={item.buttonNotReceiveImg}
                                            style={{
                                                position: "absolute",
                                                bottom: 0,
                                            }}
                                            onClick={() => {
                                                this.receiveMarketingPrizes();
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        );
                    }
                })}

                {/* 获奖弹窗 */}
                {lotteryType ? (
                    <div className="lotteryDialog">
                        <div
                            className="lotteryBox"
                            style={{
                                background: `url(${
                                    lotteryItem.resultCode === 1
                                        ? assemblyLottery.winEjectImg
                                        : assemblyLottery.failEjectImg
                                }) no-repeat center center / contain`,
                            }}
                        >
                            <div className="lotteryContent">
                                <div>
                                    <img src={lotteryItem.prizeImg} />
                                </div>
                                <div>{lotteryItem.prizeName}</div>
                            </div>
                            <CloseCircleOutline
                                className="iconBtn"
                                fontSize={32}
                                color="#fff"
                                onClick={() => {
                                    this.setState({
                                        lotteryType: false,
                                        lotteryItem: {},
                                    });
                                }}
                            />
                        </div>
                    </div>
                ) : (
                    ""
                )}

                {
                    // 提示弹窗
                    dialogShow ? (
                        <div className="dialog">
                            <div className="dialogBox">
                                <div className="dialogTitle">温馨提示</div>
                                <div className="dialogContent">
                                    您当前的版本过低，为了保证顺利参与活动及领取奖励，请先升级至最新版本！否则影响奖励到账哦！安卓不低于3.3.1，苹果不低于3.5.0。
                                </div>
                                <div
                                    className="dialogBtn"
                                    onClick={() => {
                                        this.setState({
                                            dialogShow: false,
                                        });
                                    }}
                                >
                                    知道了
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )
                }

                {/* 滑块 */}
                {TPYZMtype ? (
                    <div className="TPyanzhengma">
                        <div className="HKBox">
                            <div className="HKimgBox">
                                <div className="imgbox">
                                    <img src={HK.backgroundImage} />
                                    <img
                                        src={HK.slideImage}
                                        className="HKimgSlider"
                                    />
                                </div>
                                <div className="HKtip">
                                    {TPYZMstatus === "success" ? (
                                        <div className="successText">
                                            验证成功
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {TPYZMstatus === "error" ? (
                                        <div className="errorText">
                                            验证失败,请重试
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                            <div className="HKslider">
                                <div className="sliderLine">
                                    滑动左边滑块完成上方拼图
                                </div>
                                <div
                                    className="sliderBtn"
                                    onTouchStart={this.FnStart.bind(this)}
                                ></div>
                            </div>
                            <div className="HKoperation clearfix">
                                <div
                                    className="left"
                                    onClick={() => {
                                        this.setState({
                                            TPYZMtype: false,
                                        });
                                    }}
                                ></div>
                                <div
                                    className="right"
                                    onClick={() => {
                                        this.getCreateSlideImage();
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}
export default ActivityModuleIndex;



// WEBPACK FOOTER //
// ./src/ActivityModule/index/index.js